// extracted by mini-css-extract-plugin
export default {"devToolsWrapper":"dev-tools__devToolsWrapper","devToolsButtons":"dev-tools__devToolsButtons","devToolBtn":"dev-tools__devToolBtn"};